import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Spinner } from 'react-bootstrap';

const AdminToolsMain = ({ auth }) => {
  const history = useHistory();

  useEffect(() => {
    if (auth === null || auth === undefined) return;
    if (auth === false) {
      history.push('/');
      return;
    }
    if (!auth.id || auth.role !== 'admin') {
      history.push('/');
      return;
    }
    // Redirect to access codes by default
    history.replace('/admin/tools/access-codes');
  }, [auth, history]);

  return (
    <Container style={{ paddingTop: '100px', paddingBottom: '2rem' }} className="text-center">
      <Spinner animation="border" />
    </Container>
  );
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(AdminToolsMain);
